// extracted by mini-css-extract-plugin
export default {"primary":"PrimaryButton_primary__sfZbk"};